import { useTypedParams } from '@sorare/routing';

import { ScoutingCenter } from 'components/scoutingCenter/ScoutingCenter';

import type { PageParams } from './__generated__/routeParams';

const ScoutingCenterSo5CompetitionPage = () => {
  const { slug } = useTypedParams<PageParams>();
  return <ScoutingCenter slug={slug} />;
};

export default ScoutingCenterSo5CompetitionPage;
